import { SearchOutlined } from "@ant-design/icons";
import { Button, Select } from "antd";
import { useEffect, useState } from "react";
import CypressTestIds from "../../../cypress/CypressTestIds";

const { Option } = Select;

const TagSearchInput = ({ value, onChange, loadingDataTags, dataTags, onSearch }) => {
    const [selectedValues, setSelectedValues] = useState(value);

    useEffect(() => {
        setSelectedValues(value);
    }, [value]);

    const onTagsChange = (value) => {
        setSelectedValues(value);
        onChange(value);
    };

    return (
        <div className="flex w-full flex-row flex-nowrap gap-4">
            <div className="flex-1">
                <Select
                    mode="tags"
                    placeholder="Tag Search: search for a tags to add as a duplicate match"
                    loading={loadingDataTags}
                    value={selectedValues}
                    onChange={onTagsChange}
                    data-testid={CypressTestIds.DUPLICATE_SEARCH_CONFIG_TAG_SEARCH_SELECT}
                >
                    {dataTags.map((dataTag, index) => (
                        <Option key={dataTag.tagId} value={dataTag.tagName}>{`${dataTag.tagName}`}</Option>
                    ))}
                </Select>
            </div>
            <div className="flex-none">
                <Button icon={<SearchOutlined />} onClick={onSearch} data-testid={CypressTestIds.DUPLICATE_SEARCH_CONFIG_SEARCH_BUTTON}></Button>
            </div>
        </div>
    );
};

export default TagSearchInput;
